module.exports = "/images/Jadlog_v2.png?1c863cc8291df28bfa0019cf277fb2ac";